module.exports = __webpack_public_path__ + "static/media/image00.04a8d8d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/image00.jpg
// module id = 24
// module chunks = 0